import { render } from "./CardRenderItemComponent.vue?vue&type=template&id=349ef79b&ts=true"
import script from "./CardRenderItemComponent.vue?vue&type=script&lang=ts"
export * from "./CardRenderItemComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__